import * as React from 'react';
import { SvgComponentProps, Svg } from './svg-component';

export const TypeType1Icon = ({ size, ...rest }: SvgComponentProps) => (
    <Svg width={size || 48} height={size || 48} viewBox="0 0 24 24" fill="none" {...rest}>
        <g clipPath="url(#clip0_8_10966)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.862 22.618A11.25 11.25 0 1 1 23.25 11.573a11.29 11.29 0 0 1-9.758 11.145v.884h-3.63v-.984Zm-1.387-11.96a2.64 2.64 0 1 1 0-5.28 2.64 2.64 0 0 1 0 5.28Zm7.05 0a2.64 2.64 0 1 1-.015-5.28 2.64 2.64 0 0 1 .015 5.28Zm-5.308 7.877c.432.29.94.446 1.46.448a2.64 2.64 0 0 0 2.64-2.633 2.633 2.633 0 1 0-4.1 2.185Zm-3.977-3.31a1.762 1.762 0 1 1-.014-3.525 1.762 1.762 0 0 1 .014 3.525Zm10.537-.285a1.763 1.763 0 1 0 1.923-2.955 1.763 1.763 0 0 0-1.923 2.955Z"
                fill="currentColor"
            />
        </g>
        <defs>
            <clipPath id="clip0_8_10966">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </Svg>
);
